export const IconTwitterx20: {
  name: 'icon_twitterx_20-3906b9574ba2'
} = {
  name: 'icon_twitterx_20-3906b9574ba2'
}
